import { render, staticRenderFns } from "./DashboardLazyRef.vue?vue&type=template&id=6ec1fdd0"
import script from "./DashboardLazyRef.vue?vue&type=script&lang=js"
export * from "./DashboardLazyRef.vue?vue&type=script&lang=js"
import style0 from "./DashboardLazyRef.vue?vue&type=style&index=0&id=6ec1fdd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports